<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Add Parking Session</p>
    </header>


    <section class="modal-card-body" style="min-width: 800px;">
      @if (loading) {
        <app-loader></app-loader>
      }

      <form [formGroup]="form">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Vehicle Plate</label>
          </div>
          <div class="field-body">
            <div class="field">
              <input class="input" type="text" formControlName="EntryLanePlate1Number" placeholder="Enter plate number">
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Controlled Area</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="select is-fullwidth">
                <select formControlName="ControlledAreaId">
                  <option value="">Select area</option>
                  @for (area of controlledAreas; track area) {
                    <option [value]="area.Id">{{area.Name}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Parking Lot</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="select is-fullwidth">
                <select formControlName="ParkingLotId">
                  <option value="">Select lot</option>
                  @for (lot of parkingLots; track lot) {
                    <option [value]="lot.Id">{{lot.Name}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Rate Set</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="select is-fullwidth">
                <select formControlName="ParkingRateSetId">
                  <option value="">Select rate set</option>
                  @for (rate of rateSets; track rate) {
                    <option [value]="rate.Id">{{rate.Name}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Entry Date</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" type="datetime-local" formControlName="ControlledAreaEntryDate">
              </div>
            </div>
          </div>
        </div>


      </form>
    </section>

    <footer class="modal-card-foot">
      <button class="button has-background-white mr-2" (click)="close()"><span class="icon"><i class="fa fa-xmark"></i></span><span>Cancel</span></button>
      <app-modal-save-button (OnSave)="confirm()"></app-modal-save-button>
    </footer>
  </div>
</div>